import { useParams } from 'react-router-dom'
import useGetAcceptedDemandLoans from '../../hooks/useGetAcceptedDemandLoans'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useCallback } from 'react'
import DotsLoading from 'components/loadings/dotsLoading'
import Item from './item'

export default function Accepted() {
    const { id } = useParams()
    const { demandLoans, isLoadingDemandLoans, fetchNextPage } =
        useGetAcceptedDemandLoans(id)
    const onWatchEnd = useCallback(() => {
        fetchNextPage()
    }, [fetchNextPage])
    return (
        <div className=" pb-16">
            {!isLoadingDemandLoans && demandLoans ? (
                <>
                    <InfiniteScroll
                        next={onWatchEnd}
                        hasMore={
                            demandLoans
                                ? demandLoans?.pages[
                                      demandLoans.pages.length - 1
                                  ].next
                                    ? true
                                    : false
                                : false
                        }
                        dataLength={
                            demandLoans
                                ? demandLoans.pages.flatMap((x) => x.results)
                                      .length
                                : 0
                        }
                        loader={<DotsLoading />}
                    >
                        <>
                            {demandLoans.pages
                                .flatMap((x) => x.results)
                                .map((item) => (
                                    <Item key={item.id} item={item} />
                                ))}
                        </>
                    </InfiniteScroll>
                </>
            ) : (
                <DotsLoading />
            )}
        </div>
    )
}
